<template>
    <div class="page-404-bg">
        <div class="wrapper-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xxl-4 col-lg-5">
                        <div class="brand-logo mb-5 text-center">
                            <router-link to="/login">
                                <img :src="`${$logoDir}logo-auth.png`" alt="HAXO" height="72" class="img-fluid">
                            </router-link>
                        </div>
                        <div class="card">
                            <div class="card-body p-4">
                                <div class="text-center">
                                    <h1 class="text-error">404</h1>
                                    <h4 class="text-uppercase text-info mt-3">Page non trouvée</h4>
                                    <p class="text-white mt-3">Il semble que vous ayez pris un mauvais chemin. Ne vous
                                        inquiétez pas... cela arrive même aux meilleurs d'entre nous.
                                    </p>
                                    <div v-if="historyLength < 2">
                                        <router-link to="/login" class="btn btn-info mt-3"><i class="mdi mdi-reply"></i> Retour</router-link>
                                    </div>
                                    <div v-else>
                                        <a class="btn btn-info mt-3" href="javascript:window.history.back()"><i class="mdi mdi-reply"></i> Retour</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="footer footer-alt text-white">
            {{ year }} © HAXO - Le contrôle d'accès connecté
        </footer>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    computed: {
        year() {
            return new Date().getFullYear();
        },
        historyLength() {
            return window.history.length;
        },
    },
}
</script>

<style scoped>
.page-404-bg {
    background: rgb(45, 64, 140);
    background: linear-gradient(164deg, rgb(32, 123, 194) 0%, rgb(45, 64, 140) 50%, rgb(114, 44, 132) 100%);
}

.page-404-bg .wrapper-pages {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 100vh;
}

.page-404-bg .card {
    background: rgba(255, 255, 255, 0.11);
    border-radius: 16px;
    -webkit-box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.page-404-bg .text-error {
    color: #fff !important;
    text-shadow: rgba(255, 255, 255, 0.3) 5px 1px, rgba(255, 255, 255, 0.2) 10px 3px;
}
</style>
